import { GzEasmScheduleControllerWebComponent } from './component/GzEasmScheduleControllerWebComponent';

export { GzEasmScheduleControllerWebComponent };
